export const secondaryNavFragment = `
  fragment secondaryNavFragment on PdpSecondaryNavigationRecord {
    navTitle
    buttons {
      ...buttonFragment
    }
  }
`;
